export default "<p>\n  signout!\n</p>\n";